import { actionTypes, selectors } from 'data'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { getCurrencies } from 'services/api/payments'

import { actions } from './slice'

const onAuth = function* () {
  yield put(actions.fetch())
}

const onFetch = function* () {
  const user = yield select(selectors.auth.getUser)
  if (!user) return
  const { error, response } = yield call(getCurrencies)

  if (error) {
    return yield put(actions.error())
  }

  yield put(actions.setData(response))
}

export default function* paymentCurrenciesMain() {
  yield takeEvery(actionTypes.auth.AUTHED, onAuth)
  yield takeEvery(actions.fetch.type, onFetch)
}
